// tslint:disable:max-line-length

import React from 'react';

export const OperatorGreaterThan = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.3,11.87V10l5-2-5-2V4.13l7.4,3.25V8.62Z" />
    </svg>
  );
};
